module.exports = __webpack_public_path__ + "media/images/app/become-vendor/hero-mobile-4b4c2a114303d12f6503f80de1ce94f8.webp";